// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { CONTRACTS_ACCESS_DEFAULT, ContractsAccessModel } from './contracts-access.model';

@State({ name: 'ContractsAccess' })
@Injectable()
export class ContractsAccessState {

  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateContractsAccess(roles: PermissionEnum[], user: UserModel): ContractsAccessModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: ContractsAccessModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): ContractsAccessModel {
    switch (role) {
      case PermissionEnum.CAN_READ_CONTRACTS:
        return {
          ...CONTRACTS_ACCESS_DEFAULT,
          canReadContracts: true
        };

      case PermissionEnum.CAN_READ_CONTRACT_BY_ID:
        return {
          ...CONTRACTS_ACCESS_DEFAULT,
          canReadContractById: true
        };
      case PermissionEnum.CAN_WRITE_CONTRACT:
        return {
          ...CONTRACTS_ACCESS_DEFAULT,
          canWriteContracts: true
        };
      case PermissionEnum.CAN_SAVE_FORCE:
        return {
          ...CONTRACTS_ACCESS_DEFAULT,
          canSaveForce: true
        };

      case PermissionEnum.CAN_READ_DEBTS:
        return {
          ...CONTRACTS_ACCESS_DEFAULT,
          canReadDebts: true
        };
      case PermissionEnum.CAN_WRITE_DEBTS:
        return {
          ...CONTRACTS_ACCESS_DEFAULT,
          canWriteDebts: true
        };

      case PermissionEnum.SUPER_USER:
        return {
          canReadContractById: true,
          canReadContracts: true,
          canWriteContracts: true,
          canReadDebts: true,
          canSaveForce: true,
          canWriteDebts: true,
          canRemoveTemplate: true
        };
      default: {
        return {
          ...CONTRACTS_ACCESS_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: ContractsAccessModel[]): ContractsAccessModel {
    const moduleConfig: ContractsAccessModel = CONTRACTS_ACCESS_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadContracts = moduleConfig.canReadContracts ? true : config.canReadContracts;
      moduleConfig.canReadContractById = moduleConfig.canReadContractById ? true : config.canReadContractById;
      moduleConfig.canWriteContracts = moduleConfig.canWriteContracts ? true : config.canWriteContracts;
      moduleConfig.canSaveForce = moduleConfig.canSaveForce ? true : config.canSaveForce;
      moduleConfig.canReadDebts = moduleConfig.canReadDebts ? true : config.canReadDebts;
      moduleConfig.canWriteDebts = moduleConfig.canWriteDebts ? true : config.canWriteDebts;
      moduleConfig.canRemoveTemplate = moduleConfig.canRemoveTemplate ? true : config.canRemoveTemplate;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToContracts(profileState: ProfileStateModel, accessState: AccessStateModel): ContractsAccessModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return ContractsAccessState.generateContractsAccess(roleList, userData);
  }

}


